<header [class]="severityClass()">
    <div class="centered header-inner">
        <h1>Bannerflow incident portal</h1>
        <h2>
            @if (incidents().length) {
                {{ incidents().length }} Ongoing incident
                @if (incidents().length > 1) {
                    s
                }
                .
                <a class="inverted" href="#incidents">See more</a>
            } @else {
                No ongoing incidents
            }
        </h2>
    </div>
</header>
